import { ReceiptStatus, type Receipt } from './CashierSellingViewModelState';

/** Date + time for Historique des ventes and related receipt lists. */
export function formatReceiptDateTime(
  date: Date,
  locale = 'fr-TN',
): string {
  return `${date.toLocaleDateString(locale)} · ${date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  })}`;
}

/**
 * Cashier shown on a past sale. Uses the person who made the sale.
 * A blank recorded name falls back to that sale's cashier id, never to whoever is logged in now.
 */
export function historyCashierLabel(sale: {
  cashierName?: string | null;
  cashierId?: string | null;
}): string {
  const name = sale.cashierName?.trim();
  if (name) return name;
  return sale.cashierId?.trim() ?? '';
}

/** Shared by Historique + Remboursement lookup (Figma refundedIds). */
export function isReceiptRefunded(
  receipt: Pick<Receipt, 'id' | 'receiptNumber' | 'status'>,
  refundedIds: Set<string>,
): boolean {
  return (
    receipt.status === ReceiptStatus.REFUNDED ||
    refundedIds.has(receipt.receiptNumber) ||
    refundedIds.has(receipt.id)
  );
}
